import { useEffect } from "react";
//
//component
//redux
//selector
//actions
export const TriggerChange = ({ audio, trigger }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (trigger) {
      const second = trigger?.split("-")[2];
      const round = parseFloat(second);
      audio.currentTime = round;
      console.log(round);
    }
  }, [audio, trigger]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerChange;
